var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtidotText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 37,
    viewBox: "0 0 137 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3328 0L0 36.1844H4.17062L16.1538 5.93283L28.137 36.1844H32.3076L32.0139 35.4795L17.9748 0H14.3328Z",
    fill: "#363ED3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1542 26.7271C17.9385 26.7271 19.3849 25.2807 19.3849 23.4964C19.3849 21.7121 17.9385 20.2656 16.1542 20.2656C14.3698 20.2656 12.9233 21.7121 12.9233 23.4964C12.9233 25.2807 14.3698 26.7271 16.1542 26.7271Z",
    fill: "#0BCB47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0524 36.1844H46.1125C42.588 36.1844 39.9447 35.1271 38.1237 33.0712C36.4202 31.074 36.009 28.6656 36.009 26.9622V3.87695H39.9447V26.9622C39.9447 30.4866 42.0006 32.3076 46.1125 32.3076H47.0524V36.1844Z",
    fill: "#363ED3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0515 10.3384H32.8362V14.2153H47.0515V10.3384Z",
    fill: "#363ED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.449 10.3384H53.572V36.1844H57.449V10.3384Z",
    fill: "#363ED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5105 6.46149C57.2948 6.46149 58.7413 5.01504 58.7413 3.23075C58.7413 1.44646 57.2948 0 55.5105 0C53.7262 0 52.2798 1.44646 52.2798 3.23075C52.2798 5.01504 53.7262 6.46149 55.5105 6.46149Z",
    fill: "#0BCB47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1694 0H85.292V36.1844H89.1694V0Z",
    fill: "#363ED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5994 36.8307C68.1393 36.8307 62.0303 30.7217 62.0303 23.2616C62.0303 15.8015 68.1393 9.69238 75.5994 9.69238C83.0598 9.69238 89.1688 15.8015 89.1688 23.2616C89.1688 30.7217 83.0598 36.8307 75.5994 36.8307ZM75.5994 13.5693C70.254 13.5693 65.9072 17.9162 65.9072 23.2616C65.9072 28.6069 70.254 32.9538 75.5994 32.9538C80.9451 32.9538 85.2914 28.6069 85.2914 23.2616C85.2914 17.9162 80.9451 13.5693 75.5994 13.5693Z",
    fill: "#363ED3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.967 36.8307C99.5074 36.8307 93.3984 30.7217 93.3984 23.2616C93.3984 15.8015 99.5074 9.69238 106.967 9.69238C114.427 9.69238 120.537 15.8015 120.537 23.2616C120.537 30.7217 114.486 36.8307 106.967 36.8307ZM106.967 13.5693C101.622 13.5693 97.275 17.9162 97.275 23.2616C97.275 28.6069 101.622 32.9538 106.967 32.9538C112.313 32.9538 116.66 28.6069 116.66 23.2616C116.66 17.9162 112.313 13.5693 106.967 13.5693Z",
    fill: "#363ED3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.691 36.1844H135.751C132.226 36.1844 129.583 35.1271 127.762 33.0712C126.058 31.074 125.647 28.6656 125.647 26.9622V3.87695H129.524V26.9622C129.524 30.4866 131.58 32.3076 135.692 32.3076H136.632V36.1844H136.691Z",
    fill: "#363ED3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.69 10.3384H122.475V14.2153H136.69V10.3384Z",
    fill: "#363ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtidotText);
export default __webpack_public_path__ + "static/media/icon-atidot-text.93afb57c557e048f5159e943556779ff.svg";
export { ForwardRef as ReactComponent };